import request from './../utils/request';

export function index(data) {
  return request({
    url: '/supplier-contracts',
    method: 'GET',
      data
  })
}

export function show(id) {
  return request({
    url: `/supplier-contracts/${id}`,
    method: 'GET'
  })
}

export function store(data) {
  return request({
    url: '/supplier-contracts',
    method: 'POST',
    data
  })
}

export function update(data) {
  return request({
    url: `/supplier-contracts/${data.id}`,
    method: 'PUT',
    data
  })
}

export function destroy(id) {
  return request({
    url: `/supplier-contracts/${id}`,
    method: 'DELETE',
  })
}

export function inventory(params) {
  return request({
    url: `/supplier-contracts/inventory`,
    method: 'GET',
    params
  });
}